import { render } from "./TrustOnboardingKyc.vue?vue&type=template&id=9ce0b278&scoped=true&ts=true"
import script from "./TrustOnboardingKyc.vue?vue&type=script&lang=ts"
export * from "./TrustOnboardingKyc.vue?vue&type=script&lang=ts"

import "./TrustOnboardingKyc.vue?vue&type=style&index=0&id=9ce0b278&scoped=true&lang=css"

import exportComponent from "/Users/pradipdobariya/Documents/projects/DMA Global/caprock-merchant-old/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9ce0b278"]])

export default __exports__